var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-tab-avaliacao" },
    [
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.loading,
            "no-data": !_vm.loading && !_vm.hasContent,
            message: _vm.emptyMessage,
            "min-height": 160
          }
        },
        [
          _c(
            "v-fade-transition",
            [
              _vm.hasScoreCard
                ? _c("TranscriptSummaryCard", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column flex-md-row align-md-center"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "detail-tab-avaliacao__score-col d-flex justify-center"
                          },
                          [
                            _c("TranscriptScoreGauge", {
                              attrs: { score: _vm.projectScore, size: 96 }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "flex-grow-1 mt-5 mt-md-0 ml-md-8" },
                          [
                            _c("TranscriptReasonAction", {
                              attrs: {
                                reason: _vm.projectReason,
                                recommendation: _vm.projectImprovement
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-fade-transition",
            [
              _vm.hasScores
                ? _c(
                    "TranscriptSummaryCard",
                    { attrs: { title: "Resumo dos critérios" } },
                    [
                      _c("TranscriptCriteriaBars", {
                        attrs: { criteria: _vm.sortedCriteria }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-fade-transition",
            [
              _vm.hasScores
                ? _c(
                    "TranscriptSummaryCard",
                    { attrs: { title: "Avaliação detalhada" } },
                    _vm._l(_vm.sortedCriteria, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass:
                            "detail-tab-avaliacao__criterion-card rounded-sm pa-3 mb-4",
                          style: { borderLeftColor: item.color }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center justify-space-between mb-2"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "az-text-primary az-size-12 font-semibold"
                                },
                                [_vm._v(" " + _vm._s(item.name) + " ")]
                              ),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "font-semibold",
                                  style: {
                                    color: item.color,
                                    backgroundColor: item.colorSoft
                                  },
                                  attrs: { small: "" }
                                },
                                [_vm._v(" " + _vm._s(item.scoreLabel) + "/10 ")]
                              )
                            ],
                            1
                          ),
                          item.reason
                            ? _c(
                                "p",
                                {
                                  staticClass: "az-text-primary az-size-14 mb-0"
                                },
                                [_vm._v(" " + _vm._s(item.reason) + " ")]
                              )
                            : _vm._e(),
                          item.improvement
                            ? _c("TranscriptRecommendationBox", {
                                staticClass: "mt-3",
                                attrs: {
                                  title: "Como melhorar",
                                  text: item.improvement
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }